import "../../index.scss"
const PagenotFound = () => {
    return (
        <div className={"divGlobalTable_notFound"}>
           <img src="/classement/notfound.png" alt="notFound" />
        </div>
    )
}
export default PagenotFound